"use client";

import { useState } from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';
import { useIsMobile } from '../lib/hooks/use-mobile';

export const TooltipWrapper = ({
  children,
  content,
  active = true,
  align = 'start',
  className,
  sideOffset = 4,
}: {
  children: React.ReactNode;
  content: React.ReactNode;
  active?: boolean;
  align?: 'start' | 'center' | 'end';
  className?: string;
  sideOffset?: number;
}) => {
  const [open, setOpen] = useState(false);
  const isMobile = useIsMobile();

  if (!active) {
    return children;
  }

  return (
    <TooltipProvider delayDuration={250}>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger
          asChild
          onClick={() => {
            if (isMobile) {
              setOpen((prev) => !prev);
            }
          }}
        >
          <span>{children}</span>
        </TooltipTrigger>
        <TooltipContent align={align} className={className} sideOffset={sideOffset}>
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
